import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
    notifyPromise,
} from "../../../Utils/Helper";

import { ADD_BANKING } from "../../Action/actionTypes";
import { addBankingFailure, addBankingSuccess } from "../../Action";


function* addBankingRequest(action) {

    try {
        const formData = action?.payload?.payload;

        const promise = API.post("/add-banking-whitelabel", formData);
        const res = yield call(notifyPromise, promise, "Adding Banking Details in progress...");

        const data = res?.data;

        if (action?.payload?.callback) {
            yield call(action?.payload?.callback, data);
        }

        if (data?.meta?.code === 200) {
            yield put(addBankingSuccess(data?.data));
            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {
            yield put(addBankingFailure());
        }
    } catch (error) {


        yield put(addBankingFailure());

    }
}



export function* watchAddBankingAPI() {
    yield takeEvery(ADD_BANKING, addBankingRequest);
}

export default function* rootSaga() {
    yield all([watchAddBankingAPI()]);
}
